import React from "react";

export type DashboardTabItem<T extends string> = {
  id: T;
  label: string;
};

type DashboardTabsProps<T extends string> = {
  activeTab: T;
  ariaLabel: string;
  items: ReadonlyArray<DashboardTabItem<T>>;
  onTabChange: (tabId: T) => void;
};

const DashboardTabs = <T extends string>({
  activeTab,
  ariaLabel,
  items,
  onTabChange,
}: DashboardTabsProps<T>) => (
  <div className="overflow-x-auto border-b border-gray-200 bg-white md:-mx-8">
    <nav
      className="flex min-w-max items-end justify-start gap-10 px-4 sm:px-8"
      aria-label={ariaLabel}
    >
      {items.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-cpaGold/30 ${
            activeTab === tab.id
              ? "border-cpaGold text-cpaGold"
              : "border-transparent text-gray-950 hover:border-gray-300 hover:text-black"
          }`}
          aria-current={activeTab === tab.id ? "page" : undefined}
          aria-label={`${tab.label} tab`}
          type="button"
        >
          {tab.label}
        </button>
      ))}
    </nav>
  </div>
);

export default DashboardTabs;
